import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../../services/firebase";
import { doc, getDoc, onSnapshot } from "firebase/firestore";
import GreenspaceJob from "./GreenspaceJob";
import StandardJob from "./StandardJob";

function resolveVariant(job, company) {
  const a = String(job?.uiVariant || "").toLowerCase();
  if (a) return a;
  const b = String(company?.uiVariant || "").toLowerCase();
  if (b) return b;
  const name = String(company?.name || job?.companyName || "").toLowerCase();
  return name.includes("greenspace") ? "greenspace" : "default";
}

export default function DriverJobRouter() {
  const { jobId } = useParams();
  const [job, setJob] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!jobId) return;
    const unsub = onSnapshot(
      doc(db, "jobs", jobId),
      async (snap) => {
        if (!snap.exists()) { setErr("Job not found"); setLoading(false); return; }
        const j = { id: snap.id, ...snap.data() };
        setJob(j);
        if (j.companyId) {
          const cs = await getDoc(doc(db, "companies", j.companyId));
          setCompany(cs.exists() ? { id: cs.id, ...cs.data() } : null);
        } else setCompany(null);
        setLoading(false);
      },
      (e) => { setErr(e.message || "Failed to load job"); setLoading(false); }
    );
    return () => unsub();
  }, [jobId]);

  if (loading) return <div className="p-4 text-sm text-gray-600">Loading job…</div>;
  if (err) return <div className="p-4 text-sm text-red-600">{err}</div>;
  if (!job) return null;

  return resolveVariant(job, company) === "greenspace"
    ? <GreenspaceJob job={job} company={company} />
    : <StandardJob   job={job} company={company} />;
}
